/// <amd-module name="Wit/Common/Controls/Boards/Interfaces" />

import { IClientWorkItem, IObservableClientWorkItem } from "Wit/ClientWorkItemService/IClientWorkItem";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { WorkItemTypeColorAndIcon } from "Wit/UI/Components/WorkItemTypeIcon/WorkItemTypeIcon.Props";

export interface WorkItemLayout<
    TWorkItem extends IClientWorkItem,
    TObservableWorkItem extends IObservableClientWorkItem<TWorkItem> = IObservableClientWorkItem<TWorkItem>
> {
    workItem: TObservableWorkItem;
    /**
     * Core fields are fields the card has special logic to display (see CoreFields Set, below).
     * coreFields is passed as a separate prop from additionalFields for historical reasons, it may make sense to factor
     * them together and add logic to <Card> to separate them. For now, Card exports a divy() function that will do
     * that.
     */
    coreFields: FieldLayoutMap;
    /** additional fields are just displayed in a big group */
    additionalFields: FieldLayout[];
    url: string;
    workItemTypeColorAndIcon: WorkItemTypeColorAndIcon;
}

export interface FieldLayout {
    referenceName: string;
    displayName: string;
    isIdentity: boolean;
    isEditable?: boolean;
}

/** maps a field reference name to FieldLayout */
export interface FieldLayoutMap {
    [fieldReferenceName: string]: FieldLayout | undefined;
}

export const CoreFields = new Set([
    CoreFieldRefNames.AssignedTo,
    CoreFieldRefNames.Id,
    CoreFieldRefNames.State,
    CoreFieldRefNames.Tags,
    // Title is currently always shown
    CoreFieldRefNames.Title
]);
